<template>
    <svg width="600" height="286" viewBox="0 0 600 286" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M386.938 -3.05176e-05L475.826 137.348C475.826 137.348 404.486 127.802 383.821 88.8389C362.962 50.0644 386.938 -3.05176e-05 386.938 -3.05176e-05Z"
            fill="#ED6B1F"
        />
        <path
            d="M454.562 5.00581L475.615 137.29C475.615 137.29 425.323 106.507 422.595 70.4645C420.061 34.6169 454.562 5.00581 454.562 5.00581Z"
            fill="#2F7DC1"
        />
        <path
            d="M422.742 70.6769C425.471 106.719 475.763 137.502 475.763 137.502L423.52 56.8489C422.742 61.1305 422.353 65.8065 422.742 70.6769Z"
            fill="#21ABD9"
        />
        <path
            d="M0 111.198H68.2231V131.845H23.5875V155.031H61.9888V174.707H23.5875V218.929H0V111.198Z"
            fill="white"
        />
        <path
            d="M77.3711 145.647H99.5917V155.388L99.9806 155.583C105.048 148.374 112.261 144.676 121.229 144.676C122.79 144.676 124.346 144.87 125.907 
                145.259V166.495C124.152 166.107 121.812 165.718 119.868 165.718C112.072 165.718 105.443 168.056 100.181 174.292V218.515H77.5713L77.3711 145.647Z"
            fill="white"
        />
        <path
            d="M184.228 173.775C182.861 165.983 177.016 161.113 169.804 161.113C162.786 161.113 156.746 165.4 154.795 173.775H184.228ZM154.99 188.191C157.524 
                198.321 165.903 202.997 176.238 202.997C184.423 202.997 193.391 200.076 200.992 195.011V213.91C193.78 218.391 182.867 220.535 173.121 220.535C148.95 
                220.535 131.603 205.535 131.603 182.544C131.603 159.163 149.728 143.969 170.004 143.969C187.935 143.969 204.893 155.854 204.893 180.4C204.893 182.932 
                204.699 186.242 204.504 188.191H154.99Z"
            fill="white"
        />
        <path
            d="M267.712 173.771C266.345 165.979 260.499 161.109 253.287 161.109C246.269 161.109 240.229 165.396 238.279 173.771H267.712ZM238.473 188.188C241.007 198.317 
                249.386 202.993 259.722 202.993C267.906 202.993 276.875 200.072 284.476 195.007V213.906C277.263 218.387 266.35 220.531 256.604 220.531C232.433 220.531 215.086 
                205.531 215.086 182.54C215.086 159.16 233.211 143.965 253.487 143.965C271.418 143.965 288.377 155.85 288.377 180.396C288.377 182.928 288.182 186.238 287.988 
                188.188H238.473Z"
            fill="white"
        />
        <path
            d="M351.732 165.537C348.421 163.976 344.52 162.616 340.036 162.616C328.145 162.616 321.71 171.579 321.71 182.486C321.71 193.393 327.95 201.773 339.058 
                201.773C343.931 201.773 348.415 200.212 351.727 198.069L351.732 165.537ZM351.932 214.824C347.059 218.328 340.43 220.471 333.412 220.471C314.892 220.471 
                299.106 206.249 299.106 183.846C299.106 160.861 315.871 144.106 337.702 144.106C343.159 144.106 347.643 145.078 351.544 146.832L351.932 
                146.638V105.337H374.542V218.917H352.321V215.018L351.932 214.824Z" 
            fill="white"
        />
        <path
            d="M428.615 200.998C438.944 200.998 446.74 192.624 446.74 182.294C446.74 171.965 438.944 163.59 428.615 163.59C418.285 163.59 410.489 171.965 410.489 
                182.294C410.489 192.624 418.479 200.998 428.615 200.998ZM428.615 143.92C452.008 143.92 469.355 160.48 469.355 182.106C469.355 203.731 452.008 220.291 
                428.615 220.291C405.221 220.291 387.874 203.731 387.874 182.106C387.874 160.48 405.416 143.92 428.615 143.92Z"
            fill="white"
        />
        <path
            d="M577.573 176.626C577.573 171.173 576.601 168.641 574.845 166.691C572.7 164.548 570.166 163.576 567.049 163.576C561.787 163.576 556.525 166.303 552.625 
                169.612C552.819 170.584 552.819 171.756 552.819 172.922V218.899H530.21V176.626C530.21 171.756 529.432 168.835 527.481 166.691C525.336 164.548 522.803 163.576 
                519.686 163.576C514.424 163.576 509.161 166.497 505.455 169.612V218.899H482.846V145.843H505.066V152.469L505.455 152.663C511.106 147.987 518.513 144.289 
                527.481 144.289C535.277 144.289 544.44 147.404 548.73 154.612C556.525 147.598 565.299 144.289 574.462 144.289C582.647 144.289 589.081 147.015 593.371 
                151.497C598.049 156.173 600 162.604 600 173.122V219.099H577.39L577.573 176.626Z"
            fill="white"
        />
        <path
            d="M515.15 240.742H522.479V229.853L535.968 226.547V240.742H547.755V251.987H535.968V267.608C535.968 272.243 537.93 274.657 541.95 274.657C544.009 274.657 
                546.15 274.025 547.755 273.409V284.12C545.517 285.19 541.869 286 538.108 286C527.57 286 522.479 280.02 522.479 269.05V252.004H515.15V240.742Z"
            fill="#2F7DC1"
        />
        <path
            d="M550.607 240.741H564.891L570.063 254.935C571.765 259.667 573.452 264.479 574.976 269.033H575.154C576.759 264.479 578.64 259.489 580.423 254.838L585.871 
                240.741H599.263L581.412 284.994H568.458L550.607 240.741Z"
            fill="#2F7DC1"
        />
    </svg>
</template>
